import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import * as Types from './purchasePlus_graphql'

export const HandleSupplierDirectoryTextTradeRelationshipFragmentDoc = gql`
  fragment HandleSupplierDirectoryTextTradeRelationship on TradeRelationship {
    isEnabled
    isEnabledBySupplier
  }
` as unknown as DocumentNode<Types.HandleSupplierDirectoryTextTradeRelationshipFragment, unknown>
